import { NavLink } from "react-router-dom";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="salon-footer">

      <div className="salon-footer-inner">

        {/* BRAND */}
        <div className="footer-brand">
          <h2>ÉLAN</h2>
          <p>Salon & Studio</p>
        </div>

        {/* NAV */}
        <nav className="footer-nav">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/gallery">Gallery</NavLink>
          <NavLink to="/team">Team</NavLink>
          <NavLink to="/reviews">Reviews</NavLink>
          <NavLink to="/faqs">FAQs</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>

        {/* INFO */}
        <div className="footer-info">
          <p>Downtown District</p>
          <p>By Appointment Only</p>
          <p>hello@elansalon.com</p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Élan Salon</span>
        <span>Designed with intention</span>
      </div>

    </footer>
  );
};

export default Footer;
